var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGhostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-icon/ghost"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 13.5797H12.0133",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 13.5797H20.0133",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.0002 2.91296C13.1712 2.91296 10.4581 4.03677 8.45769 6.03716C6.4573 8.03755 5.3335 10.7507 5.3335 13.5796V29.5796L9.3335 25.5796L12.6668 28.913L16.0002 25.5796L19.3335 28.913L22.6668 25.5796L26.6668 29.5796V13.5796C26.6668 10.7507 25.543 8.03755 23.5426 6.03716C21.5422 4.03677 18.8291 2.91296 16.0002 2.91296Z",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostIcon);
export default __webpack_public_path__ + "static/media/ghost-icon.53d54f2712acb9ee38e02803512d4c42.svg";
export { ForwardRef as ReactComponent };